import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { giv, callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, formatMoneyShorten, formatDate, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ coinsHistory, setCoinsHistory ] = useState([]);

  const getCoinsHistory = () => {
    return new Promise(async resolve => {
      setLoading(true);
      await callGameServerApi('get-coins-history', { }).then((response) => {
        setLoading(false);
        if(response.status === 1) {
          setCoinsHistory(response.coinsHistory);
          resolve();
        } else {
          appContext.tellError(response.msg);
        }
      })
    });
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await getCoinsHistory().then(() => {
      setReady(true);
    })
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Coins History"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container" style={{ paddingBottom: "40px" }}>
            <div className="row">

              <div className="col-md-12 col-sm-12" style={{ marginTop: "10px" }}>
                <div className="card text-end">
                  <div className="card-body">
                    <p className="font-semi-bold text-goldish" style={{ fontSize: "40px" }}>
                      <AiFillDollarCircle/>&nbsp;
                      {formatMoney(appContext.userData.coins)}
                    </p>
                    <small className="text-muted">Coins Balance</small>
                    <hr/>
                    <button 
                      onClick={() => appContext.navTo({ item: 'coins_shop' })} 
                      className="btn btn-block bg-blackish mNoMargin"
                      style={{
                        padding: "10px",
                      }}
                    >
                      Buy Coins
                    </button>
                  </div>
                </div>
              </div>

              {
                (coinsHistory && coinsHistory.length > 0) ?
                coinsHistory.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="col-md-12 col-sm-12"
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        borderBottom: "5px solid var(--faintBlack)"
                      }}>
                      <p style={{ fontSize: "25px" }} className="font-semi-bold text-goldish"><AiFillDollarCircle/> {formatMoney(item.amount)}</p>
                      <p className="font-light text-muted">{item.description}</p>
                      <small className="font-regular text-redish form-text">{item.action}</small>
                      <small className="font-light text-goldish form-text">Date: {item.date}</small>
                    </div>
                  )
                }):
                <div className="col-md-12 col-sm-12" style={{ marginTop: "30px" }}>
                  <small className="font-light text-redish">No Coins History was found. Buy and spend coins to see history here</small>
                </div>
              }

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
